import { createContext, useContext } from "react";

/** What the builder needs to know when the workflow it edits is one of the defaults. */
export interface DefaultWorkflowInfo {
  /** The workflow's catalogue key (`handoff_route_and_alert`). */
  systemKey: string | null;
  /** `inline` defaults run at the event itself (a handoff, a new lead): they cannot hold steps that run afterwards, such as Assign. */
  execution: "async" | "inline";
  /** The plan has workflows of the workspace's own, so a default can be duplicated (and the steps it cannot hold used in the copy). */
  canDuplicate: boolean;
}

/**
 * Set by the page of a default workflow; `null` for the workspace's own workflows. In a module of its own with only `react` to
 * import, so the provider and its readers always share one object (see `refs-context.ts`).
 */
export const DefaultWorkflowContext = createContext<DefaultWorkflowInfo | null>(null);

export function useDefaultWorkflow(): DefaultWorkflowInfo | null {
  return useContext(DefaultWorkflowContext);
}
